export const initialState = {
  loading: false,
  error: '',
  data: null,
};
